import { Component } from '@angular/core';
import { ReportsService } from 'src/app/services/reports.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { OperatorService } from 'src/app/services/operator.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent {
  constructor(
    private reprotServ: ReportsService,
    private operatorServ: OperatorService
  ) {}

  date: any;
  grossbets: any;
  visible: any;
  Code: any;
  Name: any;

  location: any;
  selectedlocation: any;

  coor: any;
  selectedcoor: any;

  drawtime: any = [
    {
      value: 'All',
    },
    {
      value: '11AM',
    },
    {
      value: '2PM',
    },
    {
      value: '4PM',
    },
    {
      value: '5PM',
    },
    {
      value: '9PM',
    },
  ];
  selecteddrawtime: any = 'All';
  ngOnInit() {
    this.date = new Date(moment().format('MM/DD/yyyy'));
    this.LoadCoors();
    this.LoadLocation();
    this.LoadGross();
  }

  LoadCoors() {
    this.operatorServ.getData().subscribe((res: any) => {
      console.log(res);
      this.coor = res.map((row: any) => {
        return {
          value: row.name,
        };
      });
    });
  }

  LoadLocation = async () => {
    this.reprotServ.getLocation().subscribe((res: any) => {
      console.log(res);
      this.location = res.map((row: any) => {
        return {
          value: row.Location,
        };
      });
    });
  };

  LoadGross = async () => {
    let newdate = this.date
      ?.toLocaleDateString('ja-JP', {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replaceAll('/', '-');
    let data = {
      date: newdate,
      location: this.selectedlocation,
      coor: this.selectedcoor,
      drawtime: this.selecteddrawtime,
    };
    await this.reprotServ.getGross(data).subscribe((res: any) => {
      this.grossbets = res;
      let GrossTotal = this.grossbets.reduce(
        (a: any, b: any) => parseInt(a) + parseInt(b.TotalGross),
        0
      );
      let HitsTotal = this.grossbets.reduce(
        (a: any, b: any) => parseInt(a) + parseInt(b.TotalHits),
        0
      );
      this.grossbets.push({
        Date: '',
        agent: 'GRAND TOTAL',
        TotalHits: HitsTotal,
        TotalGross: GrossTotal,
        NetTotal: GrossTotal - HitsTotal,
      });
      console.log(res);
    });
  };

  exportExcel() {
    let newdate = this.date
      ?.toLocaleDateString('ja-JP', {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replaceAll('/', '-');
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.grossbets);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, newdate);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName +
        `_${this.selecteddrawtime}_` +
        this.checkNullorUndefined(this.selectedcoor) +
        this.checkNullorUndefined(this.selectedlocation) +
        EXCEL_EXTENSION
    );
  }

  checkNullorUndefined(string: any) {
    if (string == undefined) {
      return '';
    } else {
      return string;
    }
  }
}
